import { SxProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MuiPagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import { TMeta } from '@onesource/schemas';
import { FC } from 'react';
import { TfiAngleDoubleLeft, TfiAngleDoubleRight, TfiAngleLeft, TfiAngleRight } from 'react-icons/tfi';

export interface IPaginationProps {
  meta: TMeta;
  sx?: SxProps;
  onNext: (pageNo: number) => void;
  onPrev: (pageNo: number) => void;
}

export const Pagination: FC<IPaginationProps> = props => {
  const { meta, sx, onNext, onPrev } = props;

  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    if (value > meta.page) {
      onNext(value);
    } else {
      onPrev(value);
    }
  };

  return (
    <Stack direction="row" alignItems="center" sx={sx}>
      <IconButton
        disabled={meta.page === 1}
        size="small"
        sx={{ color: theme => theme.palette.primary.main, mr: 0.5 }}
        onClick={() => onPrev(1)}
        title="First page"
      >
        <TfiAngleDoubleLeft size={14} />
      </IconButton>

      <MuiPagination
        size="small"
        count={meta.totalPages}
        page={meta.page}
        onChange={handleChange}
        siblingCount={1}
        boundaryCount={1}
        renderItem={item => <PaginationItem slots={{ previous: TfiAngleLeft, next: TfiAngleRight }} {...item} />}
        sx={{
          '& .MuiPaginationItem-root': { minWidth: 28, height: 32 },
        }}
      />

      <IconButton
        disabled={meta.page === meta.totalPages}
        size="small"
        sx={{ color: theme => theme.palette.primary.main, ml: 0.5 }}
        onClick={() => onNext(meta.totalPages)}
        title="Last page"
      >
        <TfiAngleDoubleRight size={14} />
      </IconButton>
    </Stack>
  );
};
